export default {
	online: {
		button: 'https://web-data.zmlearn.com/image/uXLNYVPEbC756nRRGeKgST/ac_btn_home_banner.png',
		img: 'https://web-data.zmlearn.com/image/y1kXiuePxyjq7QtZ9d76g/ac_home_banner_text.png',
	},
	class: {
		title:
			'<h1 ><span>¡Clase 1 a 1 en línea, en <p> cualquier lugar</p> y</span><span> en<p> cualquier momento</p> lo que desee!</span></h1>',
		list: [
			{
				id: 1,
				title: 'Más conveniente',
				content: 'Lo único que necesita (ud.) es su PC / iPad',
				img: 'https://web-data.zmlearn.com/image/aL42CPHh86SkiwHZpkodwx/img_p1_pic1%402x.png',
			},
			{
				id: 2,
				title: 'Más eficiente',
				content: 'Tener interacción (con tutor/a) en tiempo real y obtener respuestas a sus preguntas durante la clase',
				img: 'https://web-data.zmlearn.com/image/CoQGB5BgKYc5tEJbgMhcm/img_p1_pic2%402x.png',
			},
			{
				id: 3,
				title: 'Más inteligente',
				content: 'Grabación automática (con permiso) y siempre disponible para la revisión.',
				img: 'https://web-data.zmlearn.com/image/tQoaowQHeW6zTbZAZ7zT84/img_p1_pic3%402x.png',
			},
		],
	},
	platform: {
		title: '<h1>Plataforma de enseñanza<span> inmersiva</span> e<p> interactiva</p></h1>',
		pcImg: 'https://web-data.zmlearn.com/image/8Tbbyf1FmZDEPXXx9gP14k/img_P2%402x.png',
		padImg: 'https://web-data.zmlearn.com/image/s1vSnomYAVReoYT2f4xXqq/img_P2_2x.png',
		phoneImg: '',
		list: [
			{
				id: 1,
				title: 'Comunicación en tiempo real',
				img: 'https://web-data.zmlearn.com/image/ctUudq9ZqHNCHwY3aERuuP/icon_realtime%402x.png',
				pImg: 'https://web-data.zmlearn.com/image/nug5dhJEDEdFtHkVkXX8QL/icon_P2_realtime%402x.png',
			},
			{
				id: 2,
				title: 'Práctica Sincrónica',
				img: 'https://web-data.zmlearn.com/image/jnQHGN4DKzGfMjpDW2tPGh/icon_Synchronous%402x.png',
				pImg: 'https://web-data.zmlearn.com/image/iAwanTxBvNrLiPbVWGTtev/icon_P2_practice%402x.png',
			},
			{
				id: 3,
				title: 'Compartir material didáctico',
				img: 'https://web-data.zmlearn.com/image/cgd6wP6DcPiEtJKCJVfLEJ/icon_Synchronous-1%402x.png',
				pImg: 'https://web-data.zmlearn.com/image/mXAXGbmAb18akyfBHuEGHn/icon_P2_share%402x.png',
			},
		],
	},
	tutors: {
		title: `<h1>Más de<span> 10,000 </span> tutores \n /as<p> experimentados</p> /as</h1>`,
		list: [
			{
				id: 1,
				title: `Más de <h4>10.000  </h4>
                <span>tutores</span>`,
				top: {
					title: 'Adolph',
					content: 'Universidad de Cambridge',
				},
				bottom: [
					{
						icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
						content: 'Asignatura: inglés',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
						content: 'Nivel escolar: n.º 3 primaria-n.º 1 E.S.O',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
						content: 'Experiencia Docente: 6 años',
					},
				],
				titleIcon: 'https://web-data.zmlearn.com/image/66EULkvQh26bQDaiGSrZxT/icon_teacher%402x.png',
				icon: 'https://web-data.zmlearn.com/image/kL6XMWRDqYsKEZMeXrXhjg/img_P3_glass%402x.png',
				img: 'https://web-data.zmlearn.com/image/8GXyTGHCv9cisFmGjWksFM/img_P3_adolph%402x.png',
			},
			{
				id: 2,
				title: `las <h4>100  </h4>
                <span>mejores universidades</span>`,
				top: {
					title: 'Sophie',
					content: 'Universidad Harvard',
				},
				bottom: [
					{
						icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
						content: 'Asignatura: ciencia',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
						content: 'Nivel escolar: n.º 3-n.º 5 primaria',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
						content: 'Experiencia Docente: 5 años',
					},
				],
				titleIcon: 'https://web-data.zmlearn.com/image/ceux1b624pSnrfai94gYoY/icon_Universities%402x.png',
				icon: 'https://web-data.zmlearn.com/image/u9psA7iCXSy7mdAbcqPDwW/img_P3_plane%402x.png',
				img: 'https://web-data.zmlearn.com/image/hQN7KkRuTQfNyyupdftWC4/img_P3_Sophie%402x.png',
			},
			{
				id: 3,
				title: `tasa de aprobación del <h4>7.8% </h4>
                `,
				top: {
					title: 'Oscar',
					content: 'Universidad de Sydney',
				},
				bottom: [
					{
						icon: 'https://web-data.zmlearn.com/image/kiKx2DQty2J9e3o8SpRjMQ/icon_subject%402x.png',
						content: 'Materia: Mathmatics',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/ivsVrY3QtCkg7BZBzyrdPu/icon_grade%402x.png',
						content: 'Nivel escolar: n.º 3 primaria-n.º 1 E.S.O',
					},
					{
						icon: 'https://web-data.zmlearn.com/image/tpGMffxT7FWfXnncbdBhkv/icon_time%402x.png',
						content: 'Experiencia Docente: 6 años',
					},
				],
				titleIcon: 'https://web-data.zmlearn.com/image/3FhHKLh8SN9uShKZd6QSRp/icon_pass%402x.png',
				icon: 'https://web-data.zmlearn.com/image/6YDPq3NfTouUrp7MQxMHvJ/img_p3_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/6WRgkopEiS6GKZgR7o57vE/img_P3_Oscar%402x.png',
			},
		],
	},
	subject: {
		title: `<h1><span>Todos los niveles </span> y<p> todas las materias</p> </h1>`,
		list: [
			{
				id: 1,
				countryIcon: 'https://web-data.zmlearn.com/image/vex3qEEYzJkYU4fX7bQ32q/_United%20Kingdom%402x.png',
				img: 'https://web-data.zmlearn.com/image/bWJCqGN2pgYTgEC5CY7RXG/img_P4_United%20Kingdom%402x.png',
				country: 'United Kingdom',
			},
			{
				id: 2,
				countryIcon: 'https://web-data.zmlearn.com/image/4XJVEmGmTvMx9HWTPaSJFK/United%20State%402x.png',
				img: 'https://web-data.zmlearn.com/image/57THfLBKvbtxYYLqAbXn96/img_P4_United%20State%402x.png',
				country: 'United State',
			},
			{
				id: 3,
				countryIcon: 'https://web-data.zmlearn.com/image/jSz1N9fMN8S3ibhFtUbTiT/Spain%402x.png',
				img: 'https://web-data.zmlearn.com/image/9Fr8ynVejmSEVyMEG1F8xe/img_P4_%20Spain%402x.png',
				country: 'Spain',
			},
			{
				id: 4,
				countryIcon: 'https://web-data.zmlearn.com/image/xd3wY877ZitAtH5VenrTgK/AU%20-%20Australia%402x.png',
				img: 'https://web-data.zmlearn.com/image/hTropE9H8UaFA8u4DnC77A/img_P4_Australia%402x.png',
				country: 'Australia',
			},
			{
				id: 5,
				countryIcon: 'https://web-data.zmlearn.com/image/wJYYidrXjjP8AZTvH4KRhz/New%20Zeland%402x.png',
				img: 'https://web-data.zmlearn.com/image/qgJ42BDynLBkdPommU39ND/img_P4_%20New%20Zeland%402x.png',
				country: 'New Zealand',
			},
			{
				id: 6,
				countryIcon: 'https://web-data.zmlearn.com/image/c3ieWw49a3mhLVohRhRsYT/CA%20-%20Canada%402x.png',
				img: 'https://web-data.zmlearn.com/image/mm28RoQdPcBpnHqHw4vDex/img_P4_Canada%402x.png',
				country: 'Canada',
			},
			{
				id: 7,
				countryIcon: 'https://web-data.zmlearn.com/image/3imjd3rNgUe22NW3kh7GD4/Malaysia%402x.png',
				img: 'https://web-data.zmlearn.com/image/neZeYjTNQ8WmqLxUSagjK5/img_P4_%20Malaysia%402x.png',
				country: 'Malaysia',
			},
			{
				id: 8,
				countryIcon: 'https://web-data.zmlearn.com/image/jHTXxvqjEJXSGtExy7xtES/Hong%20Kong%2C%20China%402x.png',
				img: 'https://web-data.zmlearn.com/image/85a4tmyUPmxd6KmQDZzkg4/img_P4_Hong%20Kong%2C%20China%402x.png',
				country: 'Hong Kong, China',
			},
			{
				id: 9,
				countryIcon: 'https://web-data.zmlearn.com/image/pN5A1LaGBpxHtTgnvHZ635/Singapore%402x.png',
				img: 'https://web-data.zmlearn.com/image/p1RpqBxPF3y5Fb6HcxHfYy/img_P4_%20Singapore%402x.png',
				country: 'Singapore',
			},
		],
	},
	works: {
		title: `<h1>¿Cómo funcionan nuestros programas de tutoría<span> personalizada</span>?</h1>`,
		list: [
			{
				id: 1,
				context: `Antes de la clase de prueba: Tendrá una evaluación inicial gratuita, una clase de prueba y un reportaje de la evaluación.`,
				icon: 'https://web-data.zmlearn.com/image/bF7mSzzsZWKB3EbzEEe2Th/%E7%BC%96%E7%BB%84%2028%402x.png',
			},
			{
				id: 2,
				context: `Durante clases regulares: Disfrutará Mejores tutores, herramientas interactivas y uso compartido de material didáctico.`,
				icon: 'https://web-data.zmlearn.com/image/8aeTnVvtNjzGbugdCCbSTT/icon_in%20class%402x.png',
			},
			{
				id: 3,
				context: `Después de clases regulares: Recibirá reportajes de la evaluación y revisiones del plan de estudios (en el grupo de estudio).`,
				icon: 'https://web-data.zmlearn.com/image/3Mta35ZvgsctVaGkRe1yk9/icon_after%20class%402x.png',
			},
		],
	},
	grades: {
		title: `<h1>¡El <span>91%</span> de los estudiantes<p> mejoraron</p> sus calificaciones con nuestra ayuda!</h1>`,
		commentText: '999+ comentarios',
		list: [
			{
				id: 1,
				name: 'Amy',
				content: `Mi tutor no solo se enfoca en asignaturas académicas, sino también incorpora algunas actividades para asegurarse de que también pueda mejorar algunas de mis habilidades durante la clase. Sabe bien que el estudio académico puede ser aburrido a veces. Por ejemplo, jugar al ajedrez, me ayuda a desarrollar mis capacidades de resolución de problemas y de pensamiento crítico.`,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/w1n3gSBBmSgdC6oyGmuBmJ/img_P6_pic1%402x.png',
				dateText: '2 de julio de 2021',
			},
			{
				id: 2,
				name: 'Mike',
				content: `Esto es lo que estaba esperando. No era muy bueno en química, lo que me preocupaba especialmente antes de cada examen. Me había inscrito en un curso de química en otra escuela, pero el profesor no podía darme clases individualizados y yo todavía no podía seguir el ritmo. Pero, Airclass es diferente. Mike en AirClass es un profesor excelente, no solo me estaba enseñando a resolver problemas de química en manera personalizada, sino también la forma correcta para estudiar química. Y gracias a la escuela airclass 1-on-1 y Mike,  ahora ya no necesito más clases particulares de química.`,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/2P6iGGUHb9bGig85LA4zin/img_P7_pic3%402x.png',
				dateText: '6 de septiembre de 2021',
			},
			{
				id: 3,
				name: 'James',
				content: `Comprar sesiones de Airclass para mi hijo fue la mejor decisión que la tomé. Tu hijo mantien una alta atención en las clases con tutores de esta escuela. Atienden las necesidades individuales de mi hijo al evaluar su nivel actual de comprensión. Lo más importante es que mi hijo disfruta mucho de sus lecciones.
                Airclass realmente le ha ayudado en ciencias y matemáticas y lo ha apoyado para obtener las mejores calificaciones posibles.`,
				icon: 'https://web-data.zmlearn.com/image/jmp7nFSKojPMKHbDCYvnH1/icon_star_light%402x.png',
				img: 'https://web-data.zmlearn.com/image/3jRhGxtrsuZh5EgdKJWxGQ/img_P7_pic2%402x.png',
				dateText: '12th October, 2021',
			},
		],
	},
};
